import { Dialog, DialogContent, DialogTitle } from "@mui/material";
import { useCallback, useState } from "react";
import DialogCloseButton from "@entrilia/shared/components/DialogCloseButton";
import useFetch from "@entrilia/shared/hooks/useFetch";
import biApi from "../../../../../../../../../api/biApi";
import TransactionAttachmentsDialogContent from "./TransactionAttachmentsDialogContent";

interface Props {
  transactionNo: string;
  onClose: () => void;
}

const TransactionAttachmentsDialog = ({ transactionNo, onClose }: Props) => {
  const apiCall = useCallback(
    (signal?: AbortSignal) => biApi.getAttachedDocuments(transactionNo, signal),
    [transactionNo]
  );
  const [items, fetchError, { isFetching }] = useFetch(apiCall, {
    onSetData(data) {
      setSelectedIndex(data.findIndex((item) => item.accessible));
    },
  });
  const [selectedIndex, setSelectedIndex] = useState<number>(-1);

  const selected = items?.[selectedIndex];

  return (
    <Dialog open onClose={onClose} fullWidth maxWidth="xl" slotProps={{ paper: { sx: { height: "90vh" } } }}>
      <DialogTitle>Attachments</DialogTitle>
      <DialogCloseButton onClick={onClose} />
      <DialogContent dividers sx={{ p: 0, display: "flex" }}>
        <TransactionAttachmentsDialogContent
          items={items ?? []}
          selectedIndex={selectedIndex}
          selected={selected}
          fetchError={fetchError}
          isFetching={isFetching}
          setSelectedIndex={setSelectedIndex}
        />
      </DialogContent>
    </Dialog>
  );
};

export default TransactionAttachmentsDialog;
